import { GenericServiceRequest } from './generic-service-request';

export class GetModelBySnapShotIdentityRequest<SnapShotFrameIdentity> extends GenericServiceRequest<SnapShotFrameIdentity> {

}
